import { connect } from 'formik'
import { IntlShape, useIntl } from 'react-intl'
import { string } from 'yup'

import VariableInput from '@/pages/SpaceAppBuilder/components/VariableInput/VariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import { DeleteNotificationStepData, StepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'

//<editor-fold desc="Interfaces">
type DeleteNotificationProps = {
  readOnly?: boolean
  formik?: any
}
//</editor-fold>

const getValidationSchema = (intl: IntlShape) => {
  return {
    correlationId: string().required(intl.formatMessage(messages.deleteNotificationIdRequired))
  }
}

const getInitialValues = (stepData: DeleteNotificationStepData): StepData => ({
  correlationId: stepData.correlationId ?? ''
})
const getDeleteOperationHelpUrl = 'https://help.workgrid.com/s/article/Deleting-a-Notification-in-Workshop'

const DeleteOperation = ({ readOnly }: DeleteNotificationProps) => {
  const intl = useIntl()

  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  return (
    <VariableInput
      name={`stepData.correlationId`}
      label={intl.formatMessage(messages.deleteNotificationIdLabel)}
      placeholder={intl.formatMessage(messages.deleteNotificationIdPlaceholder)}
      variables={variables}
      required={true}
      readOnly={readOnly}
    />
  )
}

DeleteOperation.displayName = 'DeleteOperation'

export default connect(DeleteOperation)

export { getInitialValues, getValidationSchema, getDeleteOperationHelpUrl }
